import { Client } from '@/utils';
import { authQuery as authQueryAPI,staff as staffAPI } from '@/api';

const Query_Permission = 'authQuery/Query_Permission';
const Query_UserList = 'authQuery/Query_UserList';
const GET_UserInfoByUId = 'authQuery/GET_UserInfoByUId';

export default {
    state:{
        tableData: {},
        userInfoData: {},
        userResultList:[]
    },
    actions:{
        async [Query_Permission]({ commit }, { data = {}, frontCode = '' } = {}) {
            commit(Query_Permission, await Client.post(authQueryAPI.queryPermission, { data }, frontCode));
        },
        async [Query_UserList]({ commit }, { data = {}, frontCode = '', globalLoading = true } = {}) {
            commit(Query_UserList, await Client.post(authQueryAPI.queryUserList, { data }, frontCode, globalLoading));
        },
        async [GET_UserInfoByUId]({ commit }, { params = {}, frontCode = '', globalLoading = true } = {}) {
            commit(GET_UserInfoByUId, await Client.get(staffAPI.queryInfoByUId, { params }, frontCode, globalLoading));
        },
    },
    mutations:{
        [Query_Permission](state,data) {  
            state.tableData = data;
        },
        [Query_UserList](state,data) {  
            state.userResultList = data;
        },
        [GET_UserInfoByUId](state,data) {  
            state.userInfoData = data.userInfo;
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/authQuery.js